import { render, staticRenderFns } from "./FieldRequestOpenChat.vue?vue&type=template&id=d0b98d66&scoped=true"
import script from "./FieldRequestOpenChat.vue?vue&type=script&lang=js"
export * from "./FieldRequestOpenChat.vue?vue&type=script&lang=js"
import style0 from "./FieldRequestOpenChat.vue?vue&type=style&index=0&id=d0b98d66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b98d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0b98d66')) {
      api.createRecord('d0b98d66', component.options)
    } else {
      api.reload('d0b98d66', component.options)
    }
    module.hot.accept("./FieldRequestOpenChat.vue?vue&type=template&id=d0b98d66&scoped=true", function () {
      api.rerender('d0b98d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldRequestOpenChat.vue"
export default component.exports